import React from 'react';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { Check, Ruler, Scissors, Camera } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function Hero() {
  const navigate = useNavigate();
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden bg-gradient-to-b from-primary via-primary to-card" data-id="element-64">
      {/* Background overlay effect */}
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1600')] bg-cover bg-center opacity-10" data-id="element-65" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-67">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-68">
            Find Clothes That <br className="hidden md:block" data-id="element-69" />
            <span className="text-accent" data-id="element-70">Actually Fit</span>
          </h1>

          <p className="text-xl md:text-2xl text-text-muted mb-10 max-w-2xl mx-auto font-normal leading-relaxed" data-id="element-71">
            Curated petite clothing from top vendors, with AI-powered virtual
            try-on for women under 5'4"
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" id="hero-cta" data-id="element-72">
            <Button size="lg" className="w-full sm:w-auto min-w-[200px]" onClick={() => navigate('/try-it')} data-id="element-73">
              Start Your Journey
            </Button>
            <Button variant="secondary" size="lg" className="w-full sm:w-auto min-w-[200px]" data-id="element-74">
              Learn More
            </Button>
          </div>

          <p className="text-sm text-text-muted font-medium tracking-wide mt-6" data-id="element-75">
            Free • Cancel anytime • Takes 60 seconds
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5,
        duration: 0.8
      }} className="mt-16 pt-8 border-t border-border flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-76">
          <div className="flex items-center space-x-2 text-text-muted" data-id="element-77">
            <Camera className="w-5 h-5 text-accent" data-id="element-78" />
            <span className="text-sm font-medium" data-id="element-79">AI Virtual Try-On</span>
          </div>
          <div className="flex items-center space-x-2 text-text-muted" data-id="element-80">
            <Ruler className="w-5 h-5 text-accent" data-id="element-81" />
            <span className="text-sm font-medium" data-id="element-82">Height-Specific Fits</span>
          </div>
          <div className="flex items-center space-x-2 text-text-muted" data-id="element-83">
            <Check className="w-5 h-5 text-accent" data-id="element-84" />
            <span className="text-sm font-medium" data-id="element-85">Top Petite Vendors</span>
          </div>
        </motion.div>
      </div>

      {/* Gradient overlays */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-96 h-96 bg-accent/10 rounded-full blur-3xl -z-10" data-id="element-86" />
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl -z-10" data-id="element-87" />
    </section>;
}